import * as React from 'react';
import { IconSVG } from '@bytebrand/fe-ui-core-autobahn/iconsvg';
// ADV-268: opened from the profile page only, so it uses that page's dialog and button styles
// (`.pf-confirm*`, `.pf-btn*` in SettingsPage/ProfilePage.css), like ConfirmAccountDeleteModal.
class ConfirmDeliveryAddressDeleteModal extends React.Component {
    render() {
        const { t, onAccept, onDecline } = this.props;
        return (React.createElement("div", { className: "pf-confirm" },
            React.createElement("span", { className: "pf-confirm-ic", "aria-hidden": "true" },
                React.createElement(IconSVG, { name: 'warningIcon', customDimensions: true })),
            React.createElement("h4", { className: "pf-confirm-title" }, t('confirmDeliveryAddressDeleteModal.confirmDeliveryAddressDeleteTitle')),
            React.createElement("p", { className: "pf-confirm-desc" }, t('confirmDeliveryAddressDeleteModal.confirmDeliveryAddressDeleteText')),
            React.createElement("div", { className: "pf-confirm-actions" },
                React.createElement("button", { type: "button", className: "pf-btn pf-btn--outlined", onClick: onDecline }, t('confirmDeliveryAddressDeleteModal.decline')),
                React.createElement("button", { type: "button", className: "pf-btn pf-btn--destructive", onClick: onAccept }, t('confirmDeliveryAddressDeleteModal.accept')))));
    }
}
Object.defineProperty(ConfirmDeliveryAddressDeleteModal, "defaultProps", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: {
        onAccept: () => { },
        onDecline: () => { }
    }
});
export default ConfirmDeliveryAddressDeleteModal;
